(function() {
    $('.live-dropdown').selectpicker()
})()
